<ng-container [formGroup]="form">
  <div class="form-group product__notes" [hidden]="form?.disabled">
    <h3>{{ labels.notesAndTasks.notes }}</h3>

    <app-dc-textarea
      [label]="labels.notesAndTasks.notes"
      [id]="'notes'"
      type="text"
      formControlName="notes"
      [readonly]="notesAndTasks.get('notes')['readOnly']"
    ></app-dc-textarea>
  </div>
</ng-container>
<div class="form-group product__tasks" [formGroup]="notesAndTasks">
  <h3>Tasks</h3>
  <div formArrayName="tasks" [hidden]="tasks?.disabled">
    <div
      *ngFor="
        let task of tasks.controls;
        let i = index;
        let last = last;
        let first = first
      "
    >
      <div class="form-row align-items-end" [formGroupName]="i">
        <ng-container *ngIf="tasks.at(i) as group">
            <div class="form-group col-lg">
              <app-dc-input
                [label]="!i ? 'Description' : ''"
                type="text"
                formControlName="description"
                [readonly]="!canUserEdit"
              ></app-dc-input>
            </div>
            <div class="form-group col-lg-2">
              <app-dc-date-input
                formControlName="dueDate"
                [readonly]="!canUserEdit"
                [showTime]="true"
                [label]="!i ? 'Due Date' : ''">
            </app-dc-date-input>
            </div>
            <div class="form-group col-lg-1">
              <app-dc-select
                [label]="!i ? 'Status' : ''"
                closeOnSelect="true"
                [readonly]="!canUserEdit"
                [items]="taskStatusItems"
                formControlName="status"
              ></app-dc-select>
            </div>
            <app-dc-plus-minus
              *ngIf="canUserEdit"
              (minusClick)="deleteTask(i)"
              (plusClick)="addTask()"
              [showPlus]="!i ? first === last : last">
            </app-dc-plus-minus>
          </ng-container>
      </div>
    </div>
  </div>
</div>
